// extracted by mini-css-extract-plugin
export var section = "sectionCta-module--section--206ea";
export var text = "sectionCta-module--text--0395f";